/*
 * video-gallery.js — featured video player with thumbnails + prev/next.
 * Selecting a thumbnail or arrow updates the featured poster/title (it does
 * NOT auto-play); clicking the play button loads the embed iframe (lazy).
 */
if (!customElements.get('video-gallery')) {
  customElements.define(
    'video-gallery',
    class VideoGallery extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-video-frame]');
        this.poster = this.querySelector('[data-video-poster]');
        this.playButton = this.querySelector('[data-video-play]');
        this.titleEl = this.querySelector('[data-video-title]');
        this.thumbs = Array.from(this.querySelectorAll('[data-video-thumb]'));
        this.index = 0;

        if (!this.frame || !this.thumbs.length) return;

        this.thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => this.select(i));
        });
        this.querySelector('.video-gallery__arrow--prev')?.addEventListener('click', () =>
          this.select(this.index - 1)
        );
        this.querySelector('.video-gallery__arrow--next')?.addEventListener('click', () =>
          this.select(this.index + 1)
        );
        this.playButton?.addEventListener('click', () => this.play());
      }

      select(i) {
        const count = this.thumbs.length;
        this.index = ((i % count) + count) % count; // wrap
        const thumb = this.thumbs[this.index];

        this.resetFrame();
        if (this.poster && thumb.dataset.poster) this.poster.src = thumb.dataset.poster;
        if (this.titleEl) this.titleEl.textContent = thumb.dataset.title || '';
        if (this.playButton) this.playButton.dataset.embed = thumb.dataset.embed || '';

        this.thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }

      resetFrame() {
        this.frame.querySelector('iframe')?.remove();
        this.frame.classList.remove('is-playing');
      }

      play() {
        const embed = this.playButton && this.playButton.dataset.embed;
        if (!embed) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'video-gallery__iframe';
        iframe.src = embed;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', this.titleEl ? this.titleEl.textContent : 'Video');
        this.frame.appendChild(iframe);
        this.frame.classList.add('is-playing');
      }
    }
  );
}
